import { render, staticRenderFns } from "./YhcSwitch.vue.js?vue&type=template&id=f060fed4&scoped=true!=!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./YhcSwitch.vue?vue&type=template&id=f060fed4&scoped=true"
import script from "./YhcSwitch.vue.js?vue&type=script&lang=js!=!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./YhcSwitch.vue?vue&type=script&lang=js"
export * from "./YhcSwitch.vue.js?vue&type=script&lang=js!=!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./YhcSwitch.vue?vue&type=script&lang=js"
import style0 from "./YhcSwitch.vue.scss?vue&type=style&index=0&id=f060fed4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true!=!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./YhcSwitch.vue?vue&type=style&index=0&id=f060fed4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f060fed4",
  null
  
)

export default component.exports